import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ContextualField, PropertyType, AggregationMode } from '../../../models';
import * as Fields from '../../../common/helpers/contextual';
import { TableWidgetConfiguration } from '../table.configuration';

class TableContextualController implements angular.IComponentController {
    cancel: () => void;
    configuration: TableWidgetConfiguration;
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    properties: ContextualField[];
    save: () => void;
    
    private garbages: (() => void)[] = [];
    private _originalConfiguration: TableWidgetConfiguration;

    static $inject = [
        '$scope',
        '$q'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$q: angular.IQService
    ) {
    }

    $onInit() {
        this.isLoading = true;

        this._originalConfiguration = angular.copy(this.configuration);
        this.initProperties();

        this.garbages.push(this._$scope.$watch(() => this.configuration, () => {
            _.find(this.properties, p => p.propertyName === 'aggregationPeriodProperty')
                .disabled = this.configuration.aggregation.mode === AggregationMode.None;
        }, true));

        this.isLoading = false;
    }

    $onDestroy() {
        this.garbages.forEach(g => g());
    }

    private initProperties() {
        if(this.configuration.alignedOn === undefined){
            this.configuration.alignedOn = 0;
        }
        this.properties = [
            angular.copy(Fields.IsVertical),
            angular.copy(Fields.RowSpacingSelect),
            angular.copy(Fields.MaxColumns),
            angular.copy(Fields.AggregationMode),
            Fields.AggregationPeriodBuilder(this.configuration),
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            angular.copy(Fields.IsEndDateIncluded),
            angular.copy(Fields.DateFormat),
            angular.copy(Fields.AggregationColumn),
            angular.copy(Fields.NameConfiguration.HasGroupName),
            angular.copy(Fields.NameConfiguration.HasName),
            angular.copy(Fields.NameConfiguration.HasShortComment),
            angular.copy(Fields.NameConfiguration.HasUnit),
            angular.copy(Fields.NameConfiguration.HasValueType),
            {
                modelName: 'hasTrend',
                propertyType: PropertyType.Boolean,
                label: 'Trend',
                placeholder: 'Trend',
                propertyName: 'hasTrendProperty',
                required: false,
                icon: 'fa-line-chart'
            },
            {
                modelName: 'isQualityVisible',
                propertyType: PropertyType.Boolean,
                label: 'Quality',
                placeholder: 'Quality',
                propertyName: 'isQualityVisibleProperty',
                required: false,
                icon: 'fa-check'
            },
            {
                modelName: 'showOwnFields',
                propertyType: PropertyType.Boolean,
                label: 'Own fields',
                placeholder: 'Own fields',
                propertyName: 'showOwnFieldsProperty',
                required: false,
                icon: 'fa-user-plus'
            },
            angular.copy(Fields.AllowLogbookEntries),
            angular.copy(Fields.PresentationUnit)
        ];
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtTableContextual: ComponentDefinition = {
    componentId: 'wtTableContextual',
    controller: TableContextualController,
    template: require('./tableContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=?',
        configuration: '=',
        save: '&?',
        cancel: '&?'
    }
};
